// extracted by mini-css-extract-plugin
export default {"head":"landingpage_head__5+XSl","header_one":"landingpage_header_one__O30KC"};